<div class="row">
  <div class="col-lg-3 col-md-3 col-6">
    <div class="single-funfact">
      <div class="icon">
        <i class='bx bxs-trophy'></i>
      </div>
      <h3 class="odometer" data-count="22">00</h3>
      <p>Золотых сертификата в 2019г</p>
    </div>
  </div>

  <div class="col-lg-3 col-md-3 col-6">
    <div class="single-funfact">
      <div class="icon">
        <i class='bx bx-line-chart'></i>
      </div>
      <h3 class="odometer" data-count="68"></h3>
      <p>+68 увеличение среднего балла</p>
    </div>
  </div>

  <div class="col-lg-3 col-md-3 col-6">
    <div class="single-funfact">
      <div class="icon">
        <i class='bx bxs-bank'></i>
      </div>
      <h3 class="odometer" data-count="16">00</h3>
      <p>Офисов по всей стране</p>
    </div>
  </div>

  <div class="col-lg-3 col-md-3 col-6">
    <div class="single-funfact">
      <div class="icon">
        <i class='bx bx-user-pin'></i>
      </div>
      <h3 class="odometer" data-count="23500">00</h3>
      <p>Абитуриентов обучались у нас</p>
    </div>
  </div>
</div>
